import React from 'react';
import PropTypes from 'prop-types';
import PriceFormatter from './formatterComponents/PriceFormatter';
import Translate from './Translate';
import {decodeEntities} from '../api/utils';

const VariableCost = ({service}) => (
<div>
  <h3 className="titled-list__title">
    {decodeEntities(service.description)}
    {service.included ? <Translate content="incl." /> : null}
  </h3>
  {service.price.amount && service.unitDescription ? (
<div className="titled-list__body">
    {decodeEntities(service.unitDescription)}
    <span className="tilde"> ~ </span>
    <PriceFormatter price={service.price} />
</div>
  ) : null}
  {service.price.amount && !service.unitDescription ? (
<div className="titled-list__body">
    <PriceFormatter price={service.price} />
</div>
  ) : null}
</div>
);

VariableCost.PropTypes = {
  isNarrow:PropTypes.bool,
  service:PropTypes.shape({
    price:PropTypes.shape({
      amount:PropTypes.number.isRequired,
      currencyCode:PropTypes.string.isRequired,
    }).isRequired,
    included:PropTypes.bool.isRequired,
    description:PropTypes.string.isRequired,
    unitDescription:PropTypes.string,
  }).isRequired,
};

export default VariableCost;
